/* eslint-disable */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { useContext, useEffect, useState } from 'react';
import { Grid, Typography, MenuList, MenuItem } from '@rentacenter/racstrap';
import clsx from 'clsx';
import { configCall } from '../../api/user';
import { headerStyles } from '../../headerStyles';
import Helper from '../../assets/images/filled-help.png';
import JobAid from '../../assets/images/jobaid.png';
import OutsideClickHandler from 'react-outside-click-handler';
import Phone from '../../assets/images/phonegrey.png';
import NewFeature from '../../assets/images/newfeature.png';
import Settings from '../../assets/images/settings.png';
import { ReactComponent as ReportIssue } from '../../assets/images/Reports Icon.svg';
import { ReactComponent as ChatbotIcon } from '../../assets/images/ChatBotIcon.svg';
import { ChatbotWindow } from '../Chatbot/ChatbotWindow';
import { useFeatureFlagContext } from '../../context/global/global-context';
import { MenuContext } from '../../context/menuContext';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
export const HelperComponent = (props: any) => {
  const classes = headerStyles();
  const [hideHelper, setHideHelper] = useState('');
  const [isChatbotOpen, setIsChatbotOpen] = useState<boolean>(false);
  const [enableChatBot, setEnableChatBot] = useState<boolean>(false);
  const [chatBotUrl, setChatBotUrl] = useState<string>('');
  const [helperData, setHelperData]: any = useState({
    whatsNewURL: '',
    jobAidURL: '',
    serviceNowURL: '',
    phoneNumber: '-',
    reportURL: '',
  });
  let { setEnableLanguageDropdown, storeDetails, selectedLang, setSelectedLang, toggleSpanish ,setDateTimeLocalization } = useContext(MenuContext)
  const { t } = useTranslation()
  const language: any = window.sessionStorage.getItem('language')



  useEffect(() => {
    const PageLoad = async () => {
      const configPayload = {
        storeNumbers: [window.sessionStorage.getItem('storeNumber')],
        paramKeyNames: [
          'ReleaseNotesURL',
          'ServiceNowURL',
          'JobAidURL',
          'SupportContactNumber',
          'ReportIssue',
          'EnableSpanishLanguage',
          'DateTimeLocalization',
          'EnableChatBot',
          'ChatBotIframeUrl',
          'EnableTimezone'
        ],
      };
      const configResult = await configCall(configPayload);
      // setFeatureFlag(configResult.storeProfileResponse.configDetails[0].configDetails)
      if (configResult) {
        const filterReleaseNotesUrl =
          configResult.storeProfileResponse.configDetails[0].configDetails.filter(
            (el: any) => el.paramKeyName == 'ReleaseNotesURL'
          );
        const filterSNUrl =
          configResult.storeProfileResponse.configDetails[0].configDetails.filter(
            (el: any) => el.paramKeyName == 'ServiceNowURL'
          );
        const filterJobAidUrl =
          configResult.storeProfileResponse.configDetails[0].configDetails.filter(
            (el: any) => el.paramKeyName == 'JobAidURL'
          );
        const filterStorePHNumber =
          configResult.storeProfileResponse.configDetails[0].configDetails.filter(
            (el: any) => el.paramKeyName == 'SupportContactNumber'
          );
        const filterReportUrl =
          configResult.storeProfileResponse.configDetails[0].configDetails.filter(
            (el: any) => el.paramKeyName == 'ReportIssue'
          );
        const filterToggleSpanish =
          configResult.storeProfileResponse.configDetails[0].configDetails.filter(
            (el: any) => el.paramKeyName == 'EnableSpanishLanguage'
          );
          const dateFormatFlag =
          configResult.storeProfileResponse.configDetails[0].configDetails.filter(
            (el: any) => el.paramKeyName == 'DateTimeLocalization'
          );
        const filterEnableChatBot =
          configResult.storeProfileResponse.configDetails[0].configDetails.filter(
            (el: any) => el.paramKeyName == 'EnableChatBot'
          );
        const filterChatBotUrl =
          configResult.storeProfileResponse.configDetails[0].configDetails.filter(
            (el: any) => el.paramKeyName == 'ChatBotIframeUrl'
          );
        const filterEnableTimezone =
          configResult.storeProfileResponse.configDetails[0].configDetails.filter(
            (el: any) => el.paramKeyName == 'EnableTimezone'
          );
        console.log("filterToggleSpanish", filterToggleSpanish);
        setEnableLanguageDropdown(filterToggleSpanish[0]?.paramValue == '1' ? true : false)
        setDateTimeLocalization(dateFormatFlag[0]?.paramValue == '1' ? true : false)
        setEnableChatBot(filterEnableChatBot[0]?.paramValue == '1' ? true : false)
        
        // Parse and set chatbot URL
        if (filterChatBotUrl[0]?.paramValue) {
          try {
            const parsedUrl = JSON.parse(filterChatBotUrl[0].paramValue);
            setChatBotUrl(parsedUrl);
          } catch (e) {
            // If not JSON, use as is
            setChatBotUrl(filterChatBotUrl[0].paramValue);
          }
        }
        if (filterToggleSpanish[0]?.paramValue == '1') {
          const language: any = window.sessionStorage.getItem('language');
          window.sessionStorage.setItem('language', language)
          setSelectedLang(window.sessionStorage.getItem('language') == 'en' ? 'english' : window.sessionStorage.getItem('language') == 'es-US' || window.sessionStorage.getItem('language') == 'es-MX' ? 'spanish' : '')
        }
        else {
          window.sessionStorage.setItem('language', 'en')
          selectedLang = ''
          setSelectedLang(selectedLang);

        }
        if (storeDetails && storeDetails?.length > 0) {

          const language = window.sessionStorage.getItem("language")
          const filteredUnits = storeDetails.filter(
            (unit: any) => unit.accountingUnitNumber == window.sessionStorage.getItem('storeNumber')
          );
          if (filteredUnits[0]?.storeDetails?.country == 'MX' && filterToggleSpanish[0]?.paramValue == '1' && selectedLang != 'english') {
            window.sessionStorage.setItem('language', 'es-MX');
            setSelectedLang('spanish')
          }
          else if (filteredUnits[0]?.storeDetails?.country == 'US' && filterToggleSpanish[0]?.paramValue == '1' && selectedLang && selectedLang != 'english') {
            window.sessionStorage.setItem('language', 'es-US');
            setSelectedLang('spanish')
          }
          else if (filterToggleSpanish[0]?.paramValue == '1' && selectedLang == 'english') {
            window.sessionStorage.setItem('language', 'en')
          }
          else if (filterToggleSpanish[0]?.paramValue == '1' && selectedLang == 'spanish') {
            window.sessionStorage.setItem('language', filteredUnits[0]?.storeDetails?.country == 'MX' ? 'es-MX' : 'es-US')
          }
          else {
            window.sessionStorage.setItem('language', 'en')
          }

          // Include or exclude storeTimezone in storeDetails session based on EnableTimezone flag
          const isTimezoneEnabled = filterEnableTimezone[0]?.paramValue == '1';
          const existingStoreDetails = window.sessionStorage.getItem('storeDetails');
          if (existingStoreDetails) {
            try {
              const decodedDetails = JSON.parse(Buffer.from(existingStoreDetails, 'base64').toString());
              if (isTimezoneEnabled) {
                decodedDetails.storeTimezone = filteredUnits[0]?.storeDetails?.storeTimezone || decodedDetails.storeTimezone;
              } else {
                delete decodedDetails.storeTimezone;
              }
              window.sessionStorage.setItem(
                'storeDetails',
                Buffer.from(JSON.stringify(decodedDetails)).toString('base64')
              );
            } catch (e) {
              console.error('Error updating storeDetails with timezone:', e);
            }
          }
        }

        setHelperData({
          whatsNewURL: filterReleaseNotesUrl[0].paramValue,
          jobAidURL: filterJobAidUrl[0].paramValue,
          serviceNowURL: filterSNUrl[0]?.paramValue,
          phoneNumber: filterStorePHNumber[0].paramValue,
          reportURL: filterReportUrl[0].paramValue,

        });
      }
    };
    if (props.throwDropdownValue && props.throwDropdownValue.length > 0) {
      PageLoad();
    }
  }, [props.throwDropdownValue]);


  useEffect(() => {
    i18n.changeLanguage(language)
  }, [toggleSpanish, language, selectedLang]);
  const helperClicked = () => {
    hideHelper == '' ? setHideHelper('show') : setHideHelper('');
  };
  
  const handleChatbotClick = () => {
    setIsChatbotOpen(true);
    setHideHelper(''); // Close the helper menu
  };
  
  const redirectionClicked = (invoker: any) => {
    if (invoker == 'New Feature' && helperData.whatsNewURL !== '') {
      window.open(helperData.whatsNewURL, '_blank');
    } else if (invoker == 'Job Aids' && helperData.jobAidURL !== '') {
      window.open(helperData.jobAidURL, '_blank');
    } else if (invoker == 'SN Portal' && helperData.serviceNowURL !== '') {
      window.open(helperData.serviceNowURL, '_blank');
    } else if (invoker == 'Report Issue' && helperData.reportURL !== '') {
      window.open(helperData.reportURL, '_blank');
    }
  };
  return (
    <>
      <Grid
        className={classes.racDropdown}
        data-testid="profilebtn"
        onClick={helperClicked}
      >
        <a
          data-testid="logoutbtn"
          className={hideHelper === 'show' ? 'racUser show' : 'racUser'}
          id="profilemenu"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <img
            className={classes.helperIconStyle}
          src={Helper}
          alt="search-icon"
        />
      </a>
      <OutsideClickHandler onOutsideClick={() => setHideHelper('')}>
        <MenuList
          data-testid="logouttest"
          className={clsx({
            [classes.racGlobalSearchShow]: hideHelper === 'show',
          })}
          classes={{
            root: clsx(
              classes.racProfileContent,
              classes.racProfileMenu,
              classes.helperList
            ),
          }}
          aria-labelledby="profilemenu"
        >
          <MenuItem
            className={`${classes.menuItem} ${classes.cursorDefault}`}
            disableRipple
            disableTouchRipple
          >
            <Grid container>
              <Grid item md={3}>
                <Typography className={classes.helpText}>{t('Help')}</Typography>
              </Grid>
            </Grid>
          </MenuItem>
          <MenuItem
            className={`${classes.menuItem}`}
            disableRipple
            disableTouchRipple
          >
            <Grid container>
              <Grid item md={2}>
                <img
                  className={classes.racStandardInfoIcon}
                  src={NewFeature}
                  alt="new-icon"
                  onClick={() => redirectionClicked('New Feature')}
                />
              </Grid>
              <Grid item md={9}>
                <Typography onClick={() => redirectionClicked('New Feature')}>
                  {t("What's New")}
                </Typography>
              </Grid>
            </Grid>
          </MenuItem>
          <MenuItem
            className={`${classes.menuItem}`}
            disableRipple
            disableTouchRipple
          >
            <Grid container>
              <Grid item md={2}>
                <img
                  className={classes.racStandardInfoIcon}
                  src={JobAid}
                  alt="job-icon"
                  onClick={() => redirectionClicked('Job Aids')}
                />
              </Grid>
              <Grid item md={9}>
                <Typography onClick={() => redirectionClicked('Job Aids')}>
                  {t("Job Aids")}
                </Typography>
              </Grid>
            </Grid>
          </MenuItem>
          <MenuItem className={classes.menuItem}>
            <Grid container>
              <Grid item md={2}>
                <ReportIssue
                  className={classes.racStandardInfoIcon}
                  onClick={() => redirectionClicked('Report Issue')}
                />
              </Grid>
              <Grid item md={9}>
                <Typography onClick={() => redirectionClicked('Report Issue')}>
                  {t("Report an Issue")}
                </Typography>
              </Grid>
            </Grid>
          </MenuItem>
          <MenuItem
            className={`${classes.menuItem}`}
            disableRipple
            disableTouchRipple
          >
            <Grid container>
              <Grid item md={2}>
                <img
                  className={classes.racStandardInfoIcon}
                  src={Settings}
                  alt="settings-icon"
                  onClick={() => redirectionClicked('SN Portal')}
                />
              </Grid>
              <Grid item md={9}>
                <Typography onClick={() => redirectionClicked('SN Portal')}>
                  {t("ServiceNow Portal")}
                </Typography>
              </Grid>
            </Grid>
          </MenuItem>
          <MenuItem
            className={`${classes.menuItem} ${classes.cursorDefault}`}
            disableRipple
            disableTouchRipple
          >
            <Grid container>
              <Grid item md={2}>
                <img
                  className={classes.racStandardInfoIcon}
                  src={Phone}
                  alt="phone-icon"
                />
              </Grid>
              <Grid item md={9}>
                <Typography>{helperData.phoneNumber}</Typography>
              </Grid>
            </Grid>
          </MenuItem>
          {enableChatBot && (
            <MenuItem
              className={`${classes.menuItem}`}
              disableRipple
              disableTouchRipple
            >
              <Grid container>
                <Grid item md={2}>
                  <ChatbotIcon
                    className={classes.racStandardInfoIcon}
                    onClick={handleChatbotClick}
                  />
                </Grid>
                <Grid item md={9}>
                  <Typography onClick={handleChatbotClick} className={classes.mt3}>
                    {t("Upbound Assist")}
                  </Typography>
                </Grid>
              </Grid>
            </MenuItem>
          )}
        </MenuList>
      </OutsideClickHandler>
      </Grid>
      
      {/* Chatbot Window - Outside of helper's OutsideClickHandler */}
      {enableChatBot && (
        <ChatbotWindow 
          isOpen={isChatbotOpen} 
          onClose={() => {
            setIsChatbotOpen(false);
          }}
          chatBotUrl={chatBotUrl}
        />
      )}
    </>
  );
};
